import { api } from './client';

export type CronyPill = 'online' | 'warning' | 'offline' | 'unknown';
export type CronySpace = 'rondo' | 'affilmaster' | 'all';

export interface CronyJob {
  id: string;
  title: string;
  space: CronySpace;
  db: string;
  interval: string;
  description: string | null;
  pill: CronyPill;
  legacy: boolean;
  status: string | null;
  lastRun: string | null;
  lastSuccess: string | null;
  detail: string | null;
  dataThrough: string | null;
  error: string | null;
}

export interface CronySourceError {
  db: string;
  message: string;
}

export interface CronyOverview {
  jobs: CronyJob[];
  counts: Record<CronyPill, number>;
  sourceErrors: CronySourceError[];
  generatedAt: string;
}

export function fetchCrony(): Promise<CronyOverview> {
  return api.get<CronyOverview>('/api/v1/crony');
}
